import {
  saveApplicationAsDraft as saveApplicationAsDraftApi,
  submitApplication as submitApplicationApi,
  withdrawApplication as withdrawApplicationApi
} from "../../Services/portalService";
import {
  tryParse,
  evaluateShowRules,
} from "../../MPP-Common-SPA/utils/globalUtility";

export const getValidSteps = ({ template, dynamicForms, user }) => {
  const { steps } = template;

  let validSteps = {};
  let firstStep = undefined;
  let defaultValues = {};
  const applicationStepNames = [];
  var order = 0;
  var numberOfSteps = 0;
  //mapping the steps to a dictionary for faster access later
  (steps ?? [])
    .sort((a, b) => a.order - b.order)
    .forEach((step) => {
      const validStep = { ...step, order: order };

      const {
        renderer: {
          id: rendererFormId,
          props: {
            doNotCountTowardsStepCounter = false,
            isApplicationStep = false,
          } = {},
        } = {},
      } = validStep;

      let isShown = true;

      // Show rules are evaluated on portal load for the user.
      // The step is shown if at least one rule passes; the first passing rule wins.
      if (dynamicForms && user && rendererFormId) {
        const formDef = dynamicForms.find((fm) => fm.code === rendererFormId);
        const formSettings = formDef ? tryParse(formDef.template)?.formSettings : null;
        const showRules = formSettings?.showRules;

        if (showRules?.length) {
          isShown = showRules.some((rule) => evaluateShowRules(rule, user));

          if (!isShown && formSettings.defaultValuesWhenHidden) {
            defaultValues = {
              ...defaultValues,
              [step.name]: { ...formSettings.defaultValuesWhenHidden },
            };
          }
        }
      }

      if (!doNotCountTowardsStepCounter && isShown) {
        validStep.stepNumber = ++numberOfSteps;
      }

      if (isShown) {
        validSteps[`${step.name}`] = {
          ...validStep,
        };

        if (isApplicationStep) {
          applicationStepNames.push(step.name);
        }

        if (!firstStep) {
          firstStep = validSteps[`${step.name}`];
        }

        order++;
      }
    });

  return { validSteps, numberOfSteps, firstStep, applicationStepNames, defaultValues };
};

// Resolves a persisted step name that may no longer be visible. 
// This can happen if the users verification staus changes
export const resolveDisplayedStep = (stepName, { template, validSteps, firstStep }) => {
  if (stepName && validSteps[stepName]) {
    return stepName;
  }

  const orderedSteps = (template?.steps ?? [])
    .slice()
    .sort((a, b) => a.order - b.order);
  const stepIndex = orderedSteps.findIndex((step) => step.name === stepName);

  if (stepIndex >= 0) {
    const nextVisibleStep = orderedSteps
      .slice(stepIndex + 1)
      .find((step) => validSteps[step.name]);

    if (nextVisibleStep) {
      return nextVisibleStep.name;
    }
  }

  return firstStep?.name;
};

export const saveApplicationAsDraft = async ({
  applicationId,
  applicationTypeId,
  application,
}) => {
  return await saveApplicationAsDraftApi({
    applicationTypeId,
    application: JSON.stringify(application ?? {}),
    applicationId,
  });
};

export const submitApplication = async ({
  applicationId,
  applicationTypeId,
  application,
}) => {
  return await submitApplicationApi({
    applicationTypeId,
    applicationId,
    application: JSON.stringify(application ?? {}),
  });
};

export const withdrawApplication = async (applicationId) => {
  return await withdrawApplicationApi(applicationId);
};